export default function PHP_compact() {
  return (
    <div>
      <h1>PHP_compact</h1>
    </div>
  );
}
